import React, { useEffect, useState } from "react";
import { useCustomContext } from "../../../state/CustomContext";
import { callAPIForQuery } from "../../../utilities/service";
import { useNavigate, useSearchParams } from "react-router-dom";
import { cloneDeep } from "lodash";

const TenantCreate: React.FC = () => {
    const context = useCustomContext();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { state } = context;
    const getTenant = async (id: number) => {
        const response = await callAPIForQuery({ input: JSON.stringify({ id: id }), type: "get_tenant" }, "post")
        const formDataCopy: any = cloneDeep(formData);
        if (response?.[0]?.[0]) {
            Object.keys(response[0][0]).forEach((key: string) => {
                formDataCopy[key] = response[0][0][key]
            });
            setFormData(formDataCopy)
        } else {
            alert('Invalid request. Please contact your administrator');
        }

    }
    useEffect(() => {
        const id = searchParams.get("id");
        if (id)
            getTenant(Number(id));
    }, [])  // eslint-disable-line react-hooks/exhaustive-deps
    // Ensure created_by is correctly set
    const userId = state?.user_id || "";

    const [formData, setFormData] = useState({
        id: -1,
        name: "",
        phone_number: "",
        contact_person_name: "",
        contact_person_phone_number: "",
        address: "",
        pincode: "",
        emailid: "",
        isactive: "1", // Default to "Yes"
        created_by: userId,
    });

    const [errors, setErrors] = useState({
        name: "",
        phone_number: "",
        contact_person_name: "",
        contact_person_phone_number: "",
        address: "",
        pincode: "",
        emailid: "",
    });

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        setFormData((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));

        setErrors((prev) => ({
            ...prev,
            [e.target.name]: "",
        }));
    };

    const validateForm = () => {
        let valid = true;
        let newErrors = {
            name: "",
            phone_number: "",
            contact_person_name: "",
            contact_person_phone_number: "",
            address: "",
            pincode: "",
            emailid: "",
        };

        if (!formData.name.toString().trim()) {
            newErrors.name = "Tenant name is required";
            valid = false;
        }

        if (!formData.phone_number.toString().trim()) {
            newErrors.phone_number = "Phone number is required";
            valid = false;
        }

        if (!formData.contact_person_name.toString().trim()) {
            newErrors.contact_person_name = "Contact person name is required";
            valid = false;
        }

        if (!formData.contact_person_phone_number.toString().trim()) {
            newErrors.contact_person_phone_number = "Contact person phone number is required";
            valid = false;
        }

        if (!formData.address.toString().trim()) {
            newErrors.address = "Address is required";
            valid = false;
        }

        if (!formData.pincode.toString().trim()) {
            newErrors.pincode = "Pincode is required";
            valid = false;
        }

        if (!formData.emailid.toString().trim()) {
            newErrors.emailid = "Email ID is required";
            valid = false;
        }

        setErrors(newErrors);
        return valid;
    };


    const handleSubmit = async () => {
        if (!validateForm()) return;

        try {
            const response = await callAPIForQuery({ input: JSON.stringify(formData), type: "insert_update_tenant" }, "post")
            if (response.error) {
                alert("Some Error occurred")
            } else {
                alert("Saved the tenant successfully");
                navigate('/tenant-view')
            }
        } catch (error) {
            console.error("Error saving tenant:", error);
            alert("Failed to save tenant.");
        }
    };

    return (
        <>
            <div className="module-title">Tenant Creation</div>
            <div className="row">
                {/* Tenant Name */}
                <div className="form-option col-lg-3 mb-3">
                    <label className="field-title">Tenant Name</label>
                    <input type="text" name="name" value={formData.name} onChange={handleChange} className="form-control" />
                    {errors.name && <p className="text-danger">{errors.name}</p>}
                </div>

                {/* Phone Number */}
                <div className="form-option col-lg-3 mb-3">
                    <label className="field-title">Phone Number</label>
                    <input type="text" name="phone_number" value={formData.phone_number} onChange={handleChange} className="form-control" />
                    {errors.phone_number && <p className="text-danger">{errors.phone_number}</p>}
                </div>

                {/* Contact Person Name */}
                <div className="form-option col-lg-3 mb-3">
                    <label className="field-title">Contact Person Name</label>
                    <input type="text" name="contact_person_name" value={formData.contact_person_name} onChange={handleChange} className="form-control" />
                    {errors.contact_person_name && <p className="text-danger">{errors.contact_person_name}</p>}
                </div>

                {/* Contact Person Phone Number */}
                <div className="form-option col-lg-3 mb-3">
                    <label className="field-title">Contact Person Phone Number</label>
                    <input type="text" name="contact_person_phone_number" value={formData.contact_person_phone_number} onChange={handleChange} className="form-control" />
                    {errors.contact_person_phone_number && <p className="text-danger">{errors.contact_person_phone_number}</p>}
                </div>

                {/* Address */}
                <div className="form-option col-lg-3 mb-3">
                    <label className="field-title">Address</label>
                    <input type="text" name="address" value={formData.address} onChange={handleChange} className="form-control" />
                    {errors.address && <p className="text-danger">{errors.address}</p>}
                </div>

                {/* Pincode */}
                <div className="form-option col-lg-3 mb-3">
                    <label className="field-title">Pincode</label>
                    <input type="text" name="pincode" value={formData.pincode} onChange={handleChange} className="form-control" />
                    {errors.pincode && <p className="text-danger">{errors.pincode}</p>}
                </div>

                {/* Email ID */}
                <div className="form-option col-lg-3 mb-3">
                    <label className="field-title">Email ID</label>
                    <input type="email" name="emailid" value={formData.emailid} onChange={handleChange} className="form-control" />
                    {errors.emailid && <p className="text-danger">{errors.emailid}</p>}
                </div>

                {/* Is Active Dropdown */}
                <div className="form-option col-lg-3 mb-3">
                    <label className="field-title">Is Active</label>
                    <select name="isactive" value={formData.isactive} onChange={handleChange} className="form-control">
                        <option value="1">Yes</option>
                        <option value="0">No</option>
                    </select>
                </div>
            </div>

            {/* Hidden Created By Field */}
            <input type="hidden" name="created_by" value={formData.created_by} />

            {/* Submit Button */}
            <div className="action-set">
                <div>
                    <input onClick={handleSubmit} type="button" className="form-control" value={formData.id > 0 ? "Update" : "Save"} />
                </div>
            </div>
        </>
    );
};

export default TenantCreate;
